import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { StripeService } from 'src/app/services/stripe-service/stripe.service';
import { UserService } from 'src/app/services/user-service/userservice';
import { PaymentData } from 'src/app/model/stripe-models/payment/payment-data';
import { HeaderServiceService } from 'src/app/services/header-service/header-service.service';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { DialogService } from 'src/app/services/dialog-service/dialog-service.service';

@Component({
    selector: 'app-zahlungs-daten',
    templateUrl: './zahlungs-daten.component.html',
    styleUrls: ['./zahlungs-daten.component.scss'],
    standalone: false
})
export class ZahlungsDatenComponent implements OnInit {
  paymentData = [{ type: "card" }, { type: "card" }, { type: "card" }, { type: "card" }, { type: "link" }];
  paymentDatas: PaymentData[] = [];
  public user;
  public memberships;
  public activeOrg;
  toDeleteCardId: string = "";
  replacementCardId: string = "";
  showAlternativeCards: boolean = false;
  loading: boolean = false;

  constructor(private dialogService: DialogService,
    private cdr: ChangeDetectorRef,
    private stripeService: StripeService,
    private userService: UserService,
    public headerService: HeaderServiceService) { }

  ngOnInit(): void {
    this.loading = true;
    this.activeOrg = this.headerService.activeOrganisation.organisationId;
    this.stripeService.updateStripeUserDateBecauseNewPayment(this.activeOrg).pipe(
      catchError(err => {
        console.error('An error occurred while checking for duplicate Stripe payment methods: ', err);
        return of(null);
      })
    ).subscribe(() => {
      this.getPaymentData(this.activeOrg.toString());
    });
  }

  isUserAdminOfOrganisationOrPlattformAdmin() {
    return this.userService.isUserAdminOfOrganisationOrPlattformAdmin(
      this.activeOrg
    );
  }

  getPaymentData(activeOrg: string) {
    this.stripeService.getPaymentData(activeOrg, '')
      .pipe(
        catchError(error => {
          return of([]);
        })
      )
      .subscribe(data => {
        if (Array.isArray(data)) {
          this.paymentDatas = data
          this.paymentDatas.forEach(paymentData => {
            paymentData["showPossibleReplacement"] = false;
          })
          this.loading = false;
          this.cdr.detectChanges();
        } else {
          this.paymentDatas = [];
          this.loading = false;
          this.cdr.detectChanges();
        }
      });
  }

  addPaymentMethod() {
    this.stripeService.addPaymentMethod(this.activeOrg).pipe(
      catchError(error => {
        return of([]);
      })
    )
      .subscribe(data => {
        if (typeof data === "string") window.location.href = data;
        this.cdr.detectChanges();
      });
  }

  async deletePaymentMethod(PaymentMethodId: string) {
    this.dialogService
      .openConfirmDialog(
        'Wollen Sie die Zahlungsmethode wirklich löschen?',
        'Abbrechen',
        'Löschen'
      )
      .subscribe((confirmed) => {
        if (confirmed) {
          this.stripeService
            .checkPaymentMethodToDelete(this.activeOrg, PaymentMethodId)
            .subscribe(data => {
              if (typeof data == 'string') {
                this.toDeleteCardId = PaymentMethodId;
                if (data.includes("No related subscriptions found")) {
                  this.stripeService
                    .deletePaymentData(this.activeOrg.toString(), this.toDeleteCardId, '').subscribe(data => {
                      if (typeof data == 'string') {
                        this.getPaymentData(this.activeOrg.toString());
                        this.dialogService.openDialog('Zahlungsmethode gelöscht',
                          'Diese Zahlungsmethode wurde erfolgreich gelöscht.');
                      }
                      else {
                        this.dialogService.openDialog('Löschen einer Zahlungsmethode fehlgeschlagen.', 'Fehler 403: Fehlgeschlagen. Bitte versuchen Sie es später erneut.');
                      }
                    });
                }
                else {
                  if (this.paymentDatas.length > 1) {
                    this.dialogService.openDialog('Alternative Zahlungsmethode festlegen.', 'Diese Zahlungsmethode wird von mindestens einem aktiven Abonnement verwendet. Bitte wählen Sie eine Alternative aus.');
                    this.paymentDatas.forEach(paymentData => {
                      if (paymentData.id != this.toDeleteCardId) paymentData.showPossibleReplacement = true;
                    });
                    this.cdr.detectChanges();
                  }
                  else this.dialogService.openDialog('Löschung fehlgeschlagen.', 'Diese Zahlungsmethode wird von mindestens einem aktiven Abonnement verwendet. Daher kann die sie nicht gelöscht werden.');
                }
              }
              else {
                this.dialogService.openDialog('Zahlungsmethode nicht gelöscht',
                  'Fehler 403: Fehlgeschlagen. Bitte versuchen Sie es später erneut.');
              }
            })
        }
      });
  }

  replacePaymentMethod(replacementId: string) {
    this.stripeService.deletePaymentData(this.activeOrg.toString(), this.toDeleteCardId, replacementId)
      .subscribe(data => {
        if (typeof data == 'string') {
          this.getPaymentData(this.activeOrg.toString());
          this.dialogService.openDialog('Alternative Zahlungsmethode.', 'Die Zahlungsmethode wurde erfolgreich ersetzt.');
        }
        else {
          this.dialogService.openDialog('Ersetzen einer Zahlungsmethode fehlgeschlagen.', 'Fehler 403: Fehlgeschlagen. Bitte versuchen Sie es später erneut.');
        }
      });
  }
}
